"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function PersonConstructFromJSON(json) {
    return PersonConstructFromJSONTyped(json, false);
}
exports.PersonConstructFromJSON = PersonConstructFromJSON;
function PersonConstructFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'genderType': json['genderType'],
        'title': !runtime_1.exists(json, 'title') ? undefined : json['title'],
        'firstName': json['firstName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'alternativeLastName': !runtime_1.exists(json, 'alternativeLastName') ? undefined : json['alternativeLastName'],
        'knownAs': !runtime_1.exists(json, 'knownAs') ? undefined : json['knownAs'],
        'mobilePhone': !runtime_1.exists(json, 'mobilePhone') ? undefined : json['mobilePhone'],
        'alternativePhone': !runtime_1.exists(json, 'alternativePhone') ? undefined : json['alternativePhone'],
        'email': !runtime_1.exists(json, 'email') ? undefined : json['email'],
        'alternativeEmail': !runtime_1.exists(json, 'alternativeEmail') ? undefined : json['alternativeEmail'],
        'dateOfBirth': !runtime_1.exists(json, 'dateOfBirth') ? undefined : (json['dateOfBirth'] === null ? null : new Date(json['dateOfBirth'])),
        'memberOfGroup': !runtime_1.exists(json, 'memberOfGroup') ? undefined : (json['memberOfGroup'] === null ? null : json['memberOfGroup'].map(_1.GroupMembershipFromJSON)),
        'memberOfGroupType': !runtime_1.exists(json, 'memberOfGroupType') ? undefined : (json['memberOfGroupType'] === null ? null : json['memberOfGroupType'].map(_1.GroupTypeMembershipFromJSON)),
        'isHidden': !runtime_1.exists(json, 'isHidden') ? undefined : json['isHidden'],
        'address': !runtime_1.exists(json, 'address') ? undefined : _1.AddressFromJSON(json['address']),
        'maritalStatus': !runtime_1.exists(json, 'maritalStatus') ? undefined : json['maritalStatus'],
        'isDetailInDirectory': !runtime_1.exists(json, 'isDetailInDirectory') ? undefined : json['isDetailInDirectory'],
        'owners': !runtime_1.exists(json, 'owners') ? undefined : json['owners'],
        'communicationSettings': !runtime_1.exists(json, 'communicationSettings') ? undefined : _1.CommunicationSettingsFromJSON(json['communicationSettings']),
        'uniqueCode': !runtime_1.exists(json, 'uniqueCode') ? undefined : json['uniqueCode'],
        'isActive': !runtime_1.exists(json, 'isActive') ? undefined : json['isActive'],
        'profileImage': !runtime_1.exists(json, 'profileImage') ? undefined : json['profileImage'],
        'profileImageFilename': !runtime_1.exists(json, 'profileImageFilename') ? undefined : json['profileImageFilename'],
        'belongsTo': !runtime_1.exists(json, 'belongsTo') ? undefined : json['belongsTo'],
        'belongsToApprovedAndActive': !runtime_1.exists(json, 'belongsToApprovedAndActive') ? undefined : json['belongsToApprovedAndActive'],
        'protectedProperties': !runtime_1.exists(json, 'protectedProperties') ? undefined : json['protectedProperties'],
        'entityId': !runtime_1.exists(json, 'entityId') ? undefined : json['entityId'],
        'properties': !runtime_1.exists(json, 'properties') ? undefined : json['properties'],
        'integration': !runtime_1.exists(json, 'integration') ? undefined : _1.IntegrationFromJSON(json['integration']),
    };
}
exports.PersonConstructFromJSONTyped = PersonConstructFromJSONTyped;
function PersonConstructToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'genderType': value.genderType,
        'title': value.title,
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'alternativeLastName': value.alternativeLastName,
        'knownAs': value.knownAs,
        'mobilePhone': value.mobilePhone,
        'alternativePhone': value.alternativePhone,
        'email': value.email,
        'alternativeEmail': value.alternativeEmail,
        'dateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth === null ? null : value.dateOfBirth.toISOString()),
        'isHidden': value.isHidden,
        'address': _1.AddressToJSON(value.address),
        'maritalStatus': value.maritalStatus,
        'isDetailInDirectory': value.isDetailInDirectory,
        'communicationSettings': _1.CommunicationSettingsToJSON(value.communicationSettings),
        'profileImage': value.profileImage,
        'entityId': value.entityId,
        'properties': value.properties,
        'integration': _1.IntegrationToJSON(value.integration),
    };
}
exports.PersonConstructToJSON = PersonConstructToJSON;
